/**
 * Greek typography helpers.
 *
 * In modern Greek typography (and on official signage / publications) capital
 * letters are written WITHOUT the tonos (acute accent). Browsers, however,
 * preserve the tonos when they apply `text-transform: uppercase` to Greek
 * lower-case source text — the result looks unidiomatic ("ΣΗΜΕΊΟ ΣΥΝΆΝΤΗΣΗΣ"
 * instead of the conventional "ΣΗΜΕΙΟ ΣΥΝΑΝΤΗΣΗΣ").
 *
 * `grUpper(s)` uppercases AND strips the tonos so labels look natural without
 * relying on CSS `text-transform`.
 */

const TONE_MAP_LOWER = { 'ά': 'α', 'έ': 'ε', 'ή': 'η', 'ί': 'ι', 'ό': 'ο', 'ύ': 'υ', 'ώ': 'ω', 'ϊ': 'ι', 'ϋ': 'υ', 'ΐ': 'ι', 'ΰ': 'υ' };
const TONE_MAP_UPPER = { 'Ά': 'Α', 'Έ': 'Ε', 'Ή': 'Η', 'Ί': 'Ι', 'Ό': 'Ο', 'Ύ': 'Υ', 'Ώ': 'Ω', 'Ϊ': 'Ι', 'Ϋ': 'Υ' };

export const stripGreekTones = (s) => {
  if (!s) return s;
  return String(s).replace(/[\u0386\u0388-\u038A\u038C\u038E\u038F\u03AA\u03AB\u03AC-\u03B0\u03CC-\u03CE\u03CA\u03CB]/g, (c) => TONE_MAP_UPPER[c] || TONE_MAP_LOWER[c] || c);
};

export const grUpper = (s) => stripGreekTones(String(s || '').toUpperCase());
